
import { getStatusBarInfo, getClientCommonMessage } from '@/utils/nativeFn'
import { compareVersion } from '@/utils/compareVersion'
import store from '@/store/index'
import { onMounted, ref, computed } from 'vue'
export default {
  name: 'NewActionBar',
  props: {
    actionBarInfo: {
      type: Object,
      default: () => ({
        actionBarTitle: '', // 标题
        actionBarBg: '#ffffff' // 背景颜色
      })
    },
    needShare: {
      type: Boolean,
      default: false
    },
    backIcon: {
      default: require('../assets/images/aio/go_back_icon.png')
    },
    goBack: {
      type: Function,
      default: () => {
        console.log('goBack')
      }
    },
    goShare: {
      type: Function,
      default: () => {
        console.log('goShare')
      }
    },
    theme: {
      type: String,
      default: 'black'
    }
  },
  emits: ['goBack', 'goShare'],
  setup(props, { emit }) {
    const showActionBar = ref(false)
    const statusBarHeight = ref(35)
    const actionBarHeight = ref(79)
    const whiteArrow = require('../assets/images/aio/left-arrow.png')
    const actionBarInfo = computed(() => props.actionBarInfo)
    onMounted(() => {
      initActionBarVisible()
    })
    const statusBarHeightRem = computed(() => {
      console.log('statusBarHeight', statusBarHeight.value)
      return statusBarHeight.value + 'px'
    })
    const actionBarHeightRem = computed(() => {
      console.log('statusBarHeight', actionBarHeight.value)
      return actionBarHeight.value + 'px'
    })
    const goBack = () => {
      console.log('back')
      emit('goBack')
    }
    const goShare = () => {
      console.log('share')
      emit('goShare')
    }
    // 获取状态栏高度
    const getStatusBarHeight = () => {
      store.commit('SET_ACTIONBARHEIGHT', actionBarHeight.value)
      getStatusBarInfo({}, (res) => {
        // console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
        statusBarHeight.value = res.height
        actionBarHeight.value = 44 + res.height || 35
        store.commit('SET_ACTIONBARHEIGHT', actionBarHeight.value)
      })
    }
    // 获取版本判断是否展示actionbar
    const initActionBarVisible = () => {
      const timer = setInterval(() => {
        getClientCommonMessage({}, (res) => {
          clearInterval(timer)
          const versionName = res?.service_version_name
          if (compareVersion(versionName, '1.8.0') !== -1) {
            // 获取状态栏高度 + 计算actionBar高度
            showActionBar.value = true
            getStatusBarHeight()
          } else {
            showActionBar.value = false
          }
        })
      }, 100)
    }
    return {
      statusBarHeightRem,
      actionBarHeightRem,
      goBack,
      goShare,
      whiteArrow,
      actionBarInfo,
      showActionBar
    }
  }
}
